//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum PackageFormats {
	Lrm = 0,
	V1p2 = 1,
	V1p3 = 2
}
